import React, { useLayoutEffect, useRef, useState } from 'react';
import ThisProject from '../ThisProject';
import ImageMedia from '../../components/common/ImageMedia';
import { Gallery, Section, SignalButton, TextBox, VideoShort } from '../../components/imports';
// import useMouse from '../../hooks/useMouse'
import CountUp from 'react-countup'
import useDisplayValue from '../../hooks/useDisplayValue'
import MotionContent from '../../components/containers/MotionContent';


const Content = () => {

  /* const prStats = {
    workDuration: "5 weeks",
    files: [
      { title: "C4D Scenes", value: "" },
      { title: "C4D Scenes", value: "" }
    ]
  } */

  // const mapFilesInDirectory = async (directoryPath) => {
  //   try {
  //     const files = await import.meta.glob(`${directoryPath}/**/*.{js,jsx,ts,tsx,json}`);

  //     Object.entries(files).forEach(([key, file]) => {
  //       console.log('File:', key, file);
  //     });
  //   } catch (error) {
  //     console.error('Error importing files:', error);
  //   }
  // };

  // mapFilesInDirectory('./src/projects/barbu/assets/feedgrid');


  //  const { toDefault, toPlay } = useMouse()

  const [initCount, setInitCount] = useState(false)
  useLayoutEffect(() => {
    setTimeout(() => {
      setInitCount(true)
    }, 2000)
  }, [initCount]);

  const { formattingFn } = useDisplayValue("");
  const countUpRef = useRef(null);
  const barbuReelRef = useRef(null);;

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (

        <div className='projectContent bg-black='>

          <div className='space-y-6 w-full flex flex-col relative'>
            <MotionContent height={'lg:h-[120vh]='} offsetRange={["start end", "end center"]} translateRange={["30%", "-100%"]} className={"aspect-square"} src={require('./assets/SCN08_Packshot-&-Bathroom_R004.jpg')}>
              <ImageMedia
                key={"stats hero image"}
                src={require('./assets/SCN08_Packshot-&-Bathroom_R004.jpg')}
                className="relative md:landscape:scale-[110%] full object-cover object-top"
              />
            </MotionContent>

            <div className='relative flex flex-col lg:flex-row w-full items-start justify-start gap-4 h-full'>
              <div className='flex max-lg:portrait:w-full max-md:portrait:bg-white center min-w-[30vw] relative lg:min-h-[400vh] max-lg:portrait:mt-40 h-full md:landscape:items-start md:landscape:justify-start'>
                <div ref={barbuReelRef} className='stickyVideo sticky top-0 flex center overflow-x-clip'>
                  <div className='h-[100vh] max-lg:portrait:h-[80vh] mx-auto flex center relative overflow-clip  w-full border border1 '>
                    <VideoShort showControls src={require('./assets/BARBU_1080.MOV')} />
                  </div>
                </div>
              </div>

              <div className='flex flex-col w-full resp lg:!pl-0 lg:!ml-0 lg:min-h-[150vh] '>

                <Section padded className={"items-center w-full lg:pt-[40vh] h-fit bg-transparent"}>
                  <div className='group text-left w-full flex flex-col padding h-fit'>
                    <h2 className='max-w-[20ch] w-fit text-balance'>Vidéo officielle de lancement <span className='capitalize'>{thisProject.client}</span>.</h2>

                    <SignalButton link={"https://www.instagram.com/barbu_sn"} />

                  </div>

                  {/* STATS */}
                  <div className='grid grid-cols-2 lg:grid-cols-4 lg:h-[100svh]= gap-6 paddingX w-full relative mt-8'>

                    <li className='flex flex-col gap-2 items-start h-fit pb-4 border-b border1'>
                      <h2 ref={countUpRef} className='w-[4ch]'>
                        <CountUp
                          start={1}
                          end={46000}
                          duration='2.5'
                          className='m-0 p-0'
                          scrollSpyOnce
                          enableScrollSpy
                          formattingFn={formattingFn}
                          useEasing
                        />
                      </h2>
                      <h4 className='leading-none'>vues Instagram</h4>
                    </li>
                    <li className='flex flex-col gap-2 items-start h-fit pb-4 border-b border1'>
                      <h2 ref={countUpRef} className='w-[4ch]'>
                        <CountUp
                          // onStart={initCount}
                          start={1}
                          end={55}
                          duration='2.5'
                          className='m-0 p-0'
                          scrollSpyOnce
                          enableScrollSpy
                          formattingFn={formattingFn}
                          useEasing
                        />
                      </h2>
                      <h4 className='leading-none'>images produites</h4>
                    </li>
                  </div>
                </Section>

                <Section padded className={"items-center w-full bg-transparent"}>
                  <div className='text-left w-full flex flex-col padding'>
                    <h2 className='max-w-[25ch]'>Recherche & Développement (R&D) + modélisation 3D</h2>
                  </div>
                  <div className='grid grid-cols-2 lg:grid-cols-2 lg:min-h-[150svh] lg:h-fit gap-6 paddingX w-full relative *:h-auto  *:border *:border1'>
                    <ImageMedia src={require('./assets/r&d_1.png')} />
                    <ImageMedia src={require('./assets/r&d_2.png')} />
                    <ImageMedia src={require('./assets/r&d_3.jpg')} />
                    <ImageMedia src={require('./assets/r&d_4.jpg')} />
                  </div>
                </Section>

                <Section className={"items-center w-full lg:pt-44 bg-transparent"}>
                  <div className='text-left w-full flex flex-col padding'>
                    <h2 className='max-w-[25ch]'>Aperçus pour présenter les rendus produits sur le feed.</h2>
                  </div>
                  <div className='grid grid-cols-2 lg:grid-cols-4 lg:max-h-[100svh] pb-20 gap-6 paddingX w-full relative h-auto '>
                    <ImageMedia src={require('./assets/feedgrid/barbu.care-0.jpg')} />
                    <ImageMedia src={require('./assets/feedgrid/barbu.care-1.jpg')} />
                    <ImageMedia src={require('./assets/feedgrid/barbu.care-2.jpg')} />
                    <ImageMedia src={require('./assets/feedgrid/barbu.care-3.jpg')} />
                    <ImageMedia src={require('./assets/feedgrid/barbu.care-4.jpg')} />
                  </div>
                </Section>

              </div>
            </div>

            <div className='bg-gradient-to-b from-dark to-blakk  w-full relative'>
              <Section padded className='space-y-6 '>
                <TextBox resp title={"Mode d'emploi"} descr={"En réalisant les rendus 3D du kit, nous avons également anticipé la production de plusieurs autres livrables, notamment le mode d'emploi en français et en anglais, décliné en versions claire et sombre. Cette approche garantit une parfaite cohérence visuelle et éditoriale à chaque étape."} />
                <div className='resp flex relative'>
                  <ImageMedia src={require('./assets/BARBU_Card_FR_.jpg')} />
                </div>

              </Section>


              <Section >
                <TextBox resp title={"Rendus individuels"} descr={"Un lot de rendus mettant en avant chaque produit du kit."} />
                <Gallery className={"resp"} defaultSize={true} content={[
                  { type: "image", src: require('./assets/solos/BARBU_Balm.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Blade.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Brush.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Comb.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Conditionner.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Oil.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Roll.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Scissors.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Wash.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_Wash-.jpg') },
                  { type: "image", src: require('./assets/solos/BARBU_xBox.jpg') },
                ]} />

              </Section>

            </div>

          </div>
          <div className='resp relative grid grid-cols-1 lg:grid-cols-2 gap-x-4 w-full h-full lg:max-h-screen'>
            <ImageMedia className="h-full" src={require('./assets/display.jpg')} />
            <ImageMedia className="h-full" src={require('./BARBU_Kit.jpg')} />
          </div>
          <div className='h-[20vh]' />
        </div>
      )}

    </ThisProject>
  )
}

export default Content